import * as Yup from "yup";

export const baseConfigSchema = Yup.object().shape({
  visibility: Yup.boolean().required(),
  minAmount: Yup.number().typeError("Must be a number").min(0).required(),
  maxAmount: Yup.number()
    .moreThan(Yup.ref("minAmount"), "Max must be greater than min")
    .required(),
  dailyLimit: Yup.number().min(0).required(),
});
